<template>
  <div class="pain">
    <div class="pain_container">
        <div v-for="(item, index) in data" :key="index" class="pain_item">
            <div class="item_container cons" v-if="index!==2&&index!==3">
                <div class="item">
                    <img :src="item.image" style="width: 100%; height: 100%;">
                </div>
                <div class="item">
                    <p class="cons_title">{{ item.title }}</p>
                    <p class="cons_content">{{ item.content }}</p>
                </div>
            </div>
            <div class="item_container cons" v-else>
                <div class="item">
                    <p class="cons_title">{{ item.title }}</p>
                    <p class="cons_content">{{ item.content }}</p>
                </div>
                <div class="item">
                    <img :src="item.image" style="width: 100%; height: 100%;">
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { dockPainPoints } from '../../util/constant'
export default {
    name:'portPain',
    data(){
        return{
            dockPainPoints,
            pointNums:[1,2,3,4,5,6,7,8,9,10,11,12],
            painPoints:[]
        }
    },
    props:{
        data: Array
    },
    watch:{
        // data(newVal) {
        //     if (Array.isArray(newVal)) {
        //         newVal.forEach(() => {
        //             this.isHover.push(true);
        //         });
        //     }
        // }
    }
}
</script>

<style lang="less" scoped>
.pain{
    .pain_container{
        width: 1350px;
        display: flex;
        margin: 0 auto;
        background-color: aliceblue;
        flex-wrap: wrap;
        .pain_item{
            width: 50%;
            background-color: rgb(0, 0, 0);
            .item_container{
                height: 100%;
                display: flex;
                .item{
                    width: 50%;
                    height: 200px;
                }
            }
            .cons{
                background-color: #404040;
                .cons_title{
                    padding: 8% 0;
                    text-align: center;
                    font-size: 1.2rem;
                    color: #fff;
                }
                .cons_content{
                    padding: 0 10%;
                    /* text-align: center; */
                    font-size: 0.7rem;
                    line-height: 2;
                    color: #a9a9a9;
                }
            }
            .pros{
                background-color: rgb(255, 226, 109);
            }
        }
    }
}
</style>